import CustomerInfo from 'types/CustomerInfo';

let localStorageAvailable: boolean | null = null;
const fallbackMemoryMap = new Map<string, CustomerInfo>();

// Helper function to generate the storage key consistently
const generateCustomerStorageKey = (
  invoiceId: string,
  environment: string
): string => {
  return `${invoiceId}_${environment}_customerInfo`;
};

function isLocalStorageAvailable(): boolean {
  if (localStorageAvailable !== null) {
    return localStorageAvailable;
  }
  // If we haven't determined its availability yet, try to set, get, and remove
  // a record. If we can do so, and the output matches the input, we can assume
  // we have it available.
  try {
    localStorage.setItem('_', '_');
    const result = localStorage.getItem('_');
    localStorage.removeItem('_');
    localStorageAvailable = result === '_';
    return localStorageAvailable;
  } catch (e) {
    return false;
  }
}

export function getCustomerFromStorage(
  invoiceId: string,
  environment: string
): CustomerInfo | null {
  if (isLocalStorageAvailable()) {
    const storageKey = generateCustomerStorageKey(invoiceId, environment);
    const customerInfoJson = localStorage.getItem(storageKey);
    if (!customerInfoJson) return null;
    try {
      return JSON.parse(customerInfoJson);
    } catch (e) {
      return null;
    }
  } else {
    return fallbackMemoryMap.get(invoiceId) || null;
  }
}

export function putCustomerInStorage(
  invoiceId: string,
  customerInfo: CustomerInfo,
  environment: string
): void {
  if (isLocalStorageAvailable()) {
    const storageKey = generateCustomerStorageKey(invoiceId, environment);
    localStorage.setItem(storageKey, JSON.stringify(customerInfo));
  } else {
    fallbackMemoryMap.set(invoiceId, customerInfo);
  }
}
